import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { styled, createGlobalStyle } from 'styled-components';
import { useSearchParams } from '../../../../play-core/hooks/use-search-params';
import { Colors } from '../../../../play-core/styles/Colors';
import { Fonts } from '../../../../play-core/styles/Fonts';
import { VideoPlayer } from '../../components/VideoPlayer/VideoPlayer';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const screenHeightHeader = {
  default: 0,
  mediaQuery: []
};
const size = {
  viewHeight: 100,
  screenHeightHeader
};
export const EmbedPage = () => {
  const {
    t
  } = useTranslation();
  const {
    urn,
    startTime = '0',
    autoPlay,
    subdivisions
  } = useSearchParams();
  const shouldAutoPlay = autoPlay === 'true' || autoPlay === '';
  const seekPosition = parseInt(startTime);
  return /*#__PURE__*/_jsx(Fragment, {
    children: urn ? /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(GlobalStylesOverrides, {}), /*#__PURE__*/_jsx(VideoPlayer, {
        urn: urn,
        autoPlay: shouldAutoPlay,
        seekPosition: seekPosition,
        recommendations: false,
        hideSegments: convertToHideSegments(subdivisions),
        size: size,
        isEmbedded: true,
        showTitle: true
      })]
    }) : /*#__PURE__*/_jsx(NoUrn, {
      children: t('embed.urnRequired')
    })
  });
};
const convertToHideSegments = subdivisions => {
  if (subdivisions === 'true') {
    return false;
  }
  if (subdivisions === 'false') {
    return true;
  }
  return true;
};
const GlobalStylesOverrides = createGlobalStyle(["body{overflow-y:auto !important;}"]);
const NoUrn = styled.div.withConfig({
  displayName: "EmbedPage__NoUrn",
  componentId: "sc-y0wu42-0"
})(["display:flex;justify-content:center;align-self:center;width:100%;margin-top:40vh;color:", ";", ""], Colors.WHITE, Fonts.regular(20));